document.addEventListener('DOMContentLoaded', function () {
  var gallery = document.querySelector('.scene-gallery');
  var container = document.querySelector('.scene-grid');
  if (!container) return;

  // ▼ セクション設定を data-* から取得
  var configEl = document.getElementById('scene-gallery-config');
  var enableInfiniteMobile = false;
  var mobileInitialCount = 8;
  var loadMoreLabel = 'もっと見る';

  if (configEl && configEl.dataset) {
    if (typeof configEl.dataset.enableInfiniteMobile !== 'undefined') {
      enableInfiniteMobile =
        configEl.dataset.enableInfiniteMobile === 'true' ||
        configEl.dataset.enableInfiniteMobile === '1';
    }
    if (configEl.dataset.mobileInitialCount) {
      var n = parseInt(configEl.dataset.mobileInitialCount, 10);
      if (!isNaN(n)) {
        mobileInitialCount = n;
      }
    }
    if (configEl.dataset.loadMoreLabel) {
      loadMoreLabel = configEl.dataset.loadMoreLabel;
    }
  }

  var magicGrid = null;
  var videos = container.querySelectorAll('.scene-grid__video');

  /* -------------------------
     動画制御（再生/停止の切り替え）
  -------------------------- */
  function updateSingleVideo(video) {
    if (!video) return;
    var rect = video.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var inView = rect.bottom > vh * 0.1 && rect.top < vh * 0.9;

    if (inView) {
      video.play().catch(function () {});
    } else {
      video.pause();
    }
  }

  function updateAllVideos() {
    videos.forEach(function (v) {
      updateSingleVideo(v);
    });
  }

  function onScrollOrResize() {
    updateAllVideos();
  }

  window.addEventListener('scroll', onScrollOrResize);
  window.addEventListener('resize', onScrollOrResize);

  /* -------------------------
     MagicGrid 設定
  -------------------------- */
  function initMagicGrid() {
    if (window.MagicGrid) {
      // SP（〜749px）は gutter 15、それ以外は 20
      var gutterSize = window.innerWidth <= 749 ? 15 : 20;

      magicGrid = new MagicGrid({
        container: '.scene-grid',
        gutter: gutterSize,
        animate: false,
        static: true,
      });

      magicGrid.positionItems();

      // ▼ レイアウトが整ってから全体を表示
      if (gallery) {
        setTimeout(function () {
          gallery.classList.remove('scene-gallery--loading');
          gallery.classList.add('scene-gallery--ready');
        }, 300);
      }

      // 2回目以降（リサイズなど）はアニメーションあり
      magicGrid.animate = true;
      magicGrid.listen();
    } else {
      // MagicGridが読み込めないときでも一応表示
      if (gallery) {
        gallery.classList.remove('scene-gallery--loading');
        gallery.classList.add('scene-gallery--ready');
      }
    }
    // 初期の動画再生状態
    updateAllVideos();
  }

  /* -------------------------
     もっと見るボタン（SP）
  -------------------------- */
  function setupMobileInfiniteScroll() {
    if (!enableInfiniteMobile) return;
    if (window.innerWidth > 749) return;

    var items = container.querySelectorAll('.scene-grid__item');
    var total = items.length;
    if (total <= mobileInitialCount) return;

    // 初期表示以外を隠す
    items.forEach(function (item, index) {
      if (index >= mobileInitialCount) {
        item.style.display = 'none';
      }
    });

    // ボタン生成
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'scene-load-more';
    btn.textContent = loadMoreLabel || 'もっと見る';

    // グリッドのすぐ下に配置
    container.parentNode.insertBefore(btn, container.nextSibling);
    btn.style.display = 'block';

    var currentVisible = mobileInitialCount;

    btn.addEventListener('click', function () {
      var items = container.querySelectorAll('.scene-grid__item');
      var total = items.length;
      var nextVisible = currentVisible + mobileInitialCount;

      for (var i = currentVisible; i < nextVisible && i < total; i++) {
        var item = items[i];

        // MagicGrid に認識させる
        item.style.display = 'block';

        // フェードイン用クラスを一時的に付与
        item.classList.add('scene-fade-in');

        // アニメーション終了後にクラスを外す（何度でも使えるように）
        item.addEventListener('animationend', function handler(e) {
          e.currentTarget.classList.remove('scene-fade-in');
          e.currentTarget.removeEventListener('animationend', handler);
        });
      }

      currentVisible = nextVisible;

      if (currentVisible >= total) {
        btn.style.display = 'none';
      }

      // 新しいアイテムも含めて再配置＆動画判定
      if (magicGrid) {
        setTimeout(function () {
          magicGrid.positionItems();
          updateAllVideos();
        }, 10);
      } else {
        updateAllVideos();
      }
    });
  }

  /* -------------------------
     画像＋動画の読み込み待ち
     → スマホなら先に「もっと見る」セット
     → そのあと MagicGrid 初期化
  -------------------------- */
  var mediaEls = container.querySelectorAll('.scene-grid__media');
  var loaded = 0;

  function afterAllMediaLoaded() {
    setupMobileInfiniteScroll();
    initMagicGrid();
  }

  function checkLoaded() {
    loaded++;
    if (loaded === mediaEls.length) {
      afterAllMediaLoaded();
    }
  }

  if (mediaEls.length === 0) {
    afterAllMediaLoaded();
  } else {
    mediaEls.forEach(function (el) {
      var tag = el.tagName.toLowerCase();

      if (tag === 'img') {
        if (el.complete) {
          checkLoaded();
        } else {
          el.addEventListener('load', checkLoaded);
          el.addEventListener('error', checkLoaded);
        }
      } else if (tag === 'video') {
        if (el.readyState >= 1) {
          checkLoaded();
        } else {
          el.addEventListener('loadedmetadata', checkLoaded);
          el.addEventListener('error', checkLoaded);
        }
      } else {
        checkLoaded();
      }
    });
  }

  /* -------------------------
    DAY / NIGHT 切り替え
  -------------------------- */
  var globalCheckboxes = Array.prototype.slice.call(
    document.querySelectorAll('.js-night-toggle-all')
  );

  if (globalCheckboxes.length > 0) {
    function setAllChecked(checked) {
      globalCheckboxes.forEach(function (cb) {
        cb.checked = checked;
      });
    }

    function updateMode() {
      // １つ目のチェック状態を基準に：true = NIGHT, false = DAY
      var isNight = globalCheckboxes[0].checked;
      var medias = document.querySelectorAll('.js-scene-media');

      medias.forEach(function (el) {
        var type = el.dataset.mediaType;
        var daySrc = el.dataset.daySrc;
        var nightSrc = el.dataset.nightSrc || daySrc;
        var target = isNight ? nightSrc : daySrc;

        if (!daySrc) return;

        if (type === 'image') {
          el.src = target;
        } else if (type === 'video') {
          var source = el.querySelector('source') || el;

          if (source.src !== target) {
            source.src = target;
            try {
              el.load();
            } catch (e) {}

            updateSingleVideo(el);
          }
        }
      });

      if (magicGrid) {
        setTimeout(function () {
          magicGrid.positionItems();
          updateAllVideos();
        }, 10);
      } else {
        updateAllVideos();
      }
    }

    globalCheckboxes.forEach(function (cb) {
      cb.addEventListener('change', function () {
        setAllChecked(cb.checked);
        updateMode();
      });
    });

    // 初期状態を反映（初期は DAY：チェックなし想定）
    updateMode();
  }

  /* -------------------------
    スイッチのテキストアニメーション
  -------------------------- */
  var switches = document.querySelectorAll('.day-night-switch');

  switches.forEach(function (sw) {
    var checkbox = sw.querySelector('.day-night-switch__checkbox');
    var inner = sw.querySelector('.day-night-switch__inner');

    if (!checkbox || !inner) return;

    checkbox.addEventListener('change', function () {
      inner.classList.remove('is-sliding-end');
      inner.classList.add('is-sliding');

      setTimeout(function () {
        inner.classList.remove('is-sliding');
        inner.classList.add('is-sliding-end');
      }, 250);
    });
  });
});
